export const shadowDepth1 = '0 3px 5px 0 rgba(0, 0, 0, 0.1), 0 0 10px 0 rgba(0, 0, 0, 0.1)';
export const shadowDepthLight = 'rgba(149, 157, 165, 0.2) 0px 8px 24px;';
